/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * PostCart Input Action
 */
export class PostCartInput implements Msdyn365.IActionInput {
    public cartInput: IPostCartData;
    constructor(cartInput: IPostCartData) {
        this.cartInput = cartInput;
    }

    // a cache object type and an appropriate cache key
    public getCacheKey = () => `PostCart-${JSON.stringify(this.cartInput)}-${new Date().getTime()}`;
    public getCacheObjectType = () => 'PostCart';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IPostCartData {
    SalesOrg: string;
    AdditionalInfo: string;
    DistributionChannel: string;
    Division: string;
    Incoterm1: string;
    CustomerPo: string;
    OrderType: string;
    SoldToId: string | null;
    ShipToId: string | null;
    Items: IPostCartItems[];
    Step: number;
}

export interface IPostCartItems {
    Quantity: string;
    CustomerAccountNumber: string;
    Number: number;
    ProductNumber: string;
    ProductName: string;
    CustomerProductNumber: string;
    RequestedDate: Date;
    UnitOfMeasure: string;
    EndCustomerNumber: string;
    EndCustomerName: string;
}
export interface IPostCartResponseData {
    '@odata.context': string;
    Success: boolean;
    Message: string;
}

const createInput = (_: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new PostCartInput({} as IPostCartData);
};

async function action(input: PostCartInput, ctx: Msdyn365.IActionContext): Promise<IPostCartResponseData> {
    let postCardData: IPostCartResponseData = {} as IPostCartResponseData;
    await Msdyn365.sendRequest(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/SaveCart`,
        'post',
        {
            cartInput: input.cartInput
        },
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${ctx.requestContext.user.token}`
            }
        }
    )
        .then(res => {
            postCardData = res.data as IPostCartResponseData;
        })
        .catch(error => {
            console.error('Error saving cart', error);
            throw new Error('Error saving cart');
        });
    return postCardData;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IPostCartResponseData>>action,
    id: 'PostCart',
    input: createInput
});
